exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timer[data-v-bd0fb2ee]{border-top:2px dashed grey;padding-top:10px}", ""]);

// exports
